import { TFunction } from "@impero-com/common/utils/i18n";

import { RiskDirectoryForUserListDto } from "api/generated/model";
import { ReassignmentFailure } from "org/user/components/ReassignmentFailureAlert";
import { describeAdminAccessFailure } from "org/user/utils/describeAdminAccessFailure";

export function describeRiskDirectoryFailure(
    t: TFunction,
    error: unknown,
    data: RiskDirectoryForUserListDto
): ReassignmentFailure | null {
    return describeAdminAccessFailure(
        error,
        t("AccessAndAssignment_ReassignError_NoAdmin_RiskDirectories"),
        (id) =>
            data.content.find(
                (dto) => dto.resource.riskDirectory.id.toString() === id
            )?.resource.riskDirectory.title ?? id
    );
}
